import Vue from 'vue'
import Vue2Editor from "vue2-editor";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import store from './store'
import '@/icons' // icon
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app']
Vue.use(ElementUI);
Vue.use(Vue2Editor);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
